import React from "react";
import DynamicCRUD from "../common/DynaminCrud";
import { getShelfConfig } from "../shelf/shelfConfig"
import PermissionDenied from "../../utils/permission_denied";
import { AuthHelper } from "../../utils/authHelper";
import { useDataManager } from "../common/userdatamanager";
import Loader from "../common/Loader";

const Shelf = ({ permissions, ...props }) => {

    const isSuperAdmin = AuthHelper.isSuperAdmin?.();

    const baseConfig = getShelfConfig(
        {},
        {},
        {
            allowEdit: permissions?.allowEdit,
            allowDelete: permissions?.allowDelete
        }
    );

    const { data, loading, error } = useDataManager(
        baseConfig.dataDependencies,
        props
    );

    if (!isSuperAdmin && !permissions?.allowView) {
        return <PermissionDenied />;
    }

    if (loading) {
        return <div className="d-flex justify-content-center p-5"><Loader /></div>;
    }

    if (error) {
        return <div className="alert alert-danger mx-3">Error loading shelf data: {error}</div>;
    }

    const finalConfig = getShelfConfig(
        { ...data, ...props },
        {},
        {
            allowEdit: permissions?.allowEdit,
            allowDelete: permissions?.allowDelete
        }
    );

    return (
        <DynamicCRUD
            {...finalConfig}
            icon="fa-solid fa-layer-group"
            permissions={permissions}
        />
    );
};

export default Shelf;
